/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformEphemerisPositionsResponse } from '../../models/platform-ephemeris-positions-response';

export interface GetEphemerisPositions$Params {

/**
 * Optioneel moment (ISO-8601, UTC). Default: nu (DateTime.UtcNow).
 */
  atUtc?: string | null;

/**
 * Optioneel: komma-gescheiden sourceKeys. Default: alle 14.
 */
  planets?: string | null;
}

export function getEphemerisPositions(http: HttpClient, rootUrl: string, params?: GetEphemerisPositions$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformEphemerisPositionsResponse>> {
  const rb = new RequestBuilder(rootUrl, getEphemerisPositions.PATH, 'get');
  if (params) {
    rb.query('atUtc', params.atUtc, {});
    rb.query('planets', params.planets, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformEphemerisPositionsResponse>;
    })
  );
}

getEphemerisPositions.PATH = '/api/Ephemeris/positions';
